import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const FileImage = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M4 16L7.29289 12.7071C7.68342 12.3166 8.31658 12.3166 8.70711 12.7071L12 16L13.2929 14.7071C13.6834 14.3166 14.3166 14.3166 14.7071 14.7071L19 19M6 20H18C19.1046 20 20 19.1046 20 18V6.00003C20 4.89546 19.1046 4.00003 18 4.00003H6C4.89543 4.00003 4 4.89546 4 6.00003V18C4 19.1046 4.89543 20 6 20Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M14.3438 9.70801C14.896 9.70801 15.3438 9.26029 15.3438 8.70801C15.3438 8.15572 14.896 7.70801 14.3438 7.70801C13.7915 7.70801 13.3438 8.15572 13.3438 8.70801C13.3438 9.26029 13.7915 9.70801 14.3438 9.70801Z'
          fill='currentColor'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </>
    ) : (
      <>
        <path
          d='M14.25 7.25C13.2835 7.25 12.5 8.0335 12.5 9C12.5 9.9665 13.2835 10.75 14.25 10.75C15.2165 10.75 16 9.9665 16 9C16 8.0335 15.2165 7.25 14.25 7.25Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.25 6C3.25 4.48122 4.48122 3.25 6 3.25H18C19.5188 3.25 20.75 4.48122 20.75 6V18C20.75 19.5188 19.5188 20.75 18 20.75H6C4.48122 20.75 3.25 19.5188 3.25 18V6ZM19.2376 18.1769C19.2458 18.1191 19.25 18.0601 19.25 18V6C19.25 5.30964 18.6904 4.75 18 4.75H6C5.30964 4.75 4.75 5.30964 4.75 6V14.1893L6.76256 12.1768C7.44598 11.4934 8.55402 11.4934 9.23744 12.1768L12 14.9393L12.7626 14.1768C13.446 13.4934 14.554 13.4934 15.2374 14.1768L19.2376 18.1769Z'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
